export default "__VITE_ASSET__CXc7V8lC__"